// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GlfXKfCaravqhK {
  position: fixed;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  height: 100vh;
  width: 100%;
  justify-content: center;
  overflow: auto;
  width: 100vw;
  z-index: 80;
}
@media only screen and (max-width: 750px) {
  .GlfXKfCaravqhK {
    overflow-y: hidden;
  }
}
.fbIpPphL5CqxR_ {
  box-shadow: var(--ds-shadow-overlay, 0px 8px 12px #091e4226, 0px 0px 1px #091e424f);
  width: 550px;
  background: var(--ds-surface-overlay, #ffffff);
  border-radius: 3px;
  border: 1px solid var(--ds-border, #091e4224);
  padding: 24px;
  position: relative;
  outline: 0;
  transition: height 0.1s ease-in-out;
  text-align: center;
  z-index: inherit;
  bottom: 10em;
}
@media only screen and (max-width: 750px) {
  .fbIpPphL5CqxR_ {
    min-width: 0;
    width: auto;
    border: 0;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
}
.YYiKouHfvVypG3 {
  height: 93px;
  margin-bottom: 32px;
}
.F72XHKScG_ybXv {
  font-weight: 500;
  margin: 0px;
}
.Ni8jSwt6y622q7 {
  font-weight: 700;
}
.Jb2COeuMAoGjLO {
  margin-top: 24px;
  margin-bottom: 0px;
}
.D6OPk9LJdQOPAP {
  font-weight: 600;
}
.nep38JlcZ_jb_v {
  text-align: left;
  padding: 16px;
  background-color: var(--ds-background-accent-blue-subtlest, #e9f2ff);
  border-radius: 3px;
  margin-top: 24px;
}
.nep38JlcZ_jb_v img {
  max-width: 100%;
}
.CazM5OODVuczgW {
  max-height: 220px;
  overflow-y: auto;
  /* Firefox */
  scrollbar-color: var(--ds-background-inverse-subtle, #00000029) transparent;
  /* Chrome, Edge, Safari */
}
.CazM5OODVuczgW::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: transparent;
}
.CazM5OODVuczgW::-webkit-scrollbar-thumb {
  background: var(--ds-background-inverse-subtle, #00000029);
  border-radius: 5px;
}
.nhWy50rKTdYLiQ {
  font-size: 11px;
  font-weight: 700;
  line-height: 16px;
  color: var(--ds-text-subtlest, #626f86);
  margin-top: 8px;
  margin-bottom: 0px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `GlfXKfCaravqhK`,
	"joinBoardModal": `fbIpPphL5CqxR_`,
	"popperImage": `YYiKouHfvVypG3`,
	"header": `F72XHKScG_ybXv`,
	"boardName": `Ni8jSwt6y622q7`,
	"button": `Jb2COeuMAoGjLO`,
	"descriptionHeader": `D6OPk9LJdQOPAP`,
	"description": `nep38JlcZ_jb_v`,
	"descriptionContent": `CazM5OODVuczgW`,
	"date": `nhWy50rKTdYLiQ`
};
export default ___CSS_LOADER_EXPORT___;
